module.exports = "../../app/cells/components/menu_bar_float_cell.rb";